var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import OutsideClickHandler from 'react-outside-click-handler';
import EnumCacheService from '@/shared/services/EnumCacheService';
import EnumMultiSelect from '@/shared/components/input/multiselect/EnumMultiSelect';
import EditableToggle from './EditableToggle';
var parseValue = function (value) {
    if (!value)
        return [];
    if (Array.isArray(value))
        return value;
    if (typeof value === 'string') {
        return value
            .replace(/\s/g, '')
            .split(',')
            .filter(Boolean)
            .map(Number)
            .filter(function (n) { return !isNaN(n); });
    }
    return [];
};
var EditableEnumMultiSelect = function (_a) {
    var onChange = _a.onChange, value = _a.value, enumType = _a.enumType, _b = _a.readOnly, readOnly = _b === void 0 ? false : _b, _c = _a.placeholder, placeholder = _c === void 0 ? '' : _c, itemMapper = _a.itemMapper;
    var intl = useIntl();
    var _d = useState([]), items = _d[0], setItems = _d[1];
    useEffect(function () {
        var mounted = true;
        EnumCacheService.getTranslated(enumType, intl, false).then(function (values) {
            if (mounted)
                setItems(values);
        });
        return function () {
            mounted = false;
        };
    }, [intl, enumType]);
    var selectedIds = parseValue(value);
    var displayValue = selectedIds
        .map(function (id) {
        var _a;
        var item = items.find(function (i) { return Number(i.id) === id; });
        return (_a = item === null || item === void 0 ? void 0 : item.label) !== null && _a !== void 0 ? _a : String(id);
    })
        .join(', ');
    var handleSubmit = useCallback(function (editValue) { return onChange(editValue || []); }, [onChange]);
    return (_jsx(EditableToggle, __assign({ onSubmit: handleSubmit, value: selectedIds, readOnly: readOnly, displayValue: displayValue ? _jsx("span", { children: displayValue }) : _jsx("i", { className: "glyphicon glyphicon-pencil" }) }, { children: function (_a) {
            var inputValue = _a.inputValue, setInputValue = _a.setInputValue, submit = _a.submit;
            return (_jsx(OutsideClickHandler, __assign({ onOutsideClick: submit }, { children: _jsx(EnumMultiSelect, { type: enumType, selection: inputValue || [], onChange: function (newSelection) { return setInputValue(newSelection); }, placeholder: placeholder, sortById: false, customItems: [], itemMapper: itemMapper }) })));
        } })));
};
export default EditableEnumMultiSelect;
